<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#3CB043" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog v-model="dialogChange" max-width="600px">
      <v-card>
        <v-layout wrap justify-center>
          <v-flex xs12>
            <v-card tile flat>
              <v-layout
                wrap
                justify-center
                px-8
                py-5
                style="background-color: #b6b6b626"
              >
                <v-flex xs11 text-left>
                  <span
                    style="
                      font-family: poppinsbold;
                      font-size: 20px;
                      color: #000000;
                    "
                  >
                    Replace cart item?
                  </span>
                </v-flex>
                <v-flex xs1>
                  <v-icon @click="dialogChange = false" color="#000000"
                    >mdi-close</v-icon
                  >
                </v-flex>
              </v-layout>
              <v-layout
                wrap
                justify-center
                py-8
                px-5
                style="
                  font-size: 16px;
                  color: #1f1f1f;
                  font-family: poppinssemibold;
                "
              >
                <v-flex xs12 sm12 text-left px-2>
                  <span
                    >Your cart contains products from another ecoshop. Do you
                    want to move those items to Wishlist and replace cart with
                    this product
                  </span>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-end py-5>
                <v-flex xs6 px-2 text-right>
                  <v-btn
                    :ripple="false"
                    depressed
                    block
                    tile
                    color="#9D9896"
                    @click="dialogChange = false"
                  >
                    <span
                      style="
                        font-family: poppinssemibold;
                        font-size: 12px;
                        color: #fff;
                        text-transform: none;
                      "
                    >
                      No
                    </span>
                  </v-btn>
                </v-flex>
                <v-flex xs6 px-2 text-right>
                  <v-btn
                    :ripple="false"
                    depressed
                    block
                    tile
                    color="#30B868"
                    @click="addCart()"
                  >
                    <span
                      style="
                        font-family: poppinssemibold;
                        font-size: 12px;
                        color: #fff;
                        text-transform: none;
                      "
                    >
                      Yes
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap justify-center fill-height py-16>
      <v-flex xs12 sm10 pt-16>
        <v-layout wrap pt-16>
          <v-flex xs12 sm12 md5 lg5 xl4>
            <v-layout wrap>
              <v-flex xs12 sm12 md12 pa-2>
                <v-card flat tile height="100%">
                  <v-layout
                    wrap
                    justify-center
                    fill-height
                    py-10
                    v-if="productData"
                  >
                    <!-- v-if="productData.photos" -->
                    <v-flex xs12 sm6 md8 align-self-center v-if="!curImage">
                      <!-- v-if="!curImage" -->
                      <!-- <v-img
                        height="100%"
                        contain
                        src="./../../assets/images/image38.png"
                      ></v-img> -->
                      <inner-image-zoom
                        zoomType="hover"
                        :hideHint="true"
                        :zoomPreload="true"
                        :src="mediaURL + productData.productImage"
                        :zoomSrc="mediaURL + productData.productImage"
                      >
                      </inner-image-zoom>
                    </v-flex>
                    <v-flex xs12 sm6 md8 align-self-center v-if="curImage">
                      <!-- <v-img
                        height="100%"
                        contain
                        src="./../../assets/images/image38.png"
                      ></v-img> -->
                      <inner-image-zoom
                        zoomType="hover"
                        :hideHint="true"
                        :zoomPreload="true"
                        :src="mediaURL + curImage"
                        :zoomSrc="mediaURL + curImage"
                      >
                      </inner-image-zoom>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-layout wrap justify-center>
                  <!-- v-for="(item, i) in productData.photos"
                  :key="i" -->
                  <v-flex xs4 sm3 md3 pa-2>
                    <v-card
                      flat
                      tile
                      @click="showImage(productData.image)"
                    >
                      <v-layout wrap justify-center fill-height>
                        <v-flex xs12 sm6 md6 align-self-center py-4>
                          <v-img
                            :src="mediaURL + productData.productImage"
                            height="80px"
                            contain
                            alt="Image"
                          >
                            <!-- :src="mediaUURL + item" -->
                            <template v-slot:placeholder>
                              <ImageLoader />
                            </template>
                          </v-img>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            sm12
            md7
            lg7
            xl8
            pl-xs0
            pl-sm-0
            pl-md-5
            pl-lg-5
            pl-xl-5
            v-if="product"
          >
            <v-layout wrap justify-center>
              <v-flex xs11>
                <v-layout wrap justify-start>
                  <v-flex xs12 text-left>
                    <span
                      style="
                        font-family: poppinssemibold;
                        font-size: 22px;
                        color: #000000;
                        text-transform: uppercase;
                      "
                    >
                      {{ product.productName }}
                    </span>
                  </v-flex>
                  <v-flex xs12 text-left>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md5 lg3 pr-5 text-left pt-2>
                        <!--  -->
                        <span v-if="product.stock != null">
                          <v-btn elevation="0" small color="#D7FFE98F" rounded>
                            <v-icon small color="#30B868"
                              >mdi-check-circle-outline</v-icon
                            >
                            <span
                              style="
                                color: #30b868;
                                font-family: poppinssemibold;
                                font-family: 12px;
                                letter-spacing: 0px;
                              "
                              >&nbsp;In Stock</span
                            ></v-btn
                          ></span
                        >
                        <span v-else>
                      <v-btn elevation="0" small color="#D7FFE98F" rounded>
                      <v-icon small color="red"
                        >mdi-close-circle-outline</v-icon
                      >
                      <span
                        style="
                          color: red;
                           font-family: poppinssemibold;
                          font-family: 12px;
                          letter-spacing: 0px;
                        "
                        >&nbsp;Out of Stock</span
                      ></v-btn
                    >
                    </span>
                      </v-flex>
                      <v-flex xs3 sm2 md3 lg2 pt-2 text-center>
                        <v-rating
                          color="#F28F34"
                          background-color="#F28F34"
                          half-increments
                          readonly
                          small
                          hover
                          v-model="product.productRating"
                        ></v-rating>
                      </v-flex>
                      <v-flex
                        xs4
                        sm2
                        md2
                        lg2
                        pt-2
                        text-left
                        pl-3
                        pl-xs-3
                        pl-sm-0
                        pl-md-0
                        pl-lg-0
                        pl-xl-0
                      >
                        <span
                          style="
                            color: #2b2b2b;
                            font-family: poppinsregular;
                            font-size: 12px;
                          "
                        >
                          <!-- {{ product.noOfFeedback }} -->
                          ({{ product.reviewCount }} reviews)</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm8 pt-2 text-left>
                    <span
                      style="
                        color: #2b2b2b;
                        font-size: 13px;
                        font-family: poppinsregular;
                      "
                      >Indulge in the exquisite taste of our eco-friendly honey,
                      harvested sustainably from pristine, pesticide-free hives.
                      This pure and delicious honey also helps preserve our
                      planet's precious ecosystems.</span
                    >
                  </v-flex>
                  <v-flex xs12 pt-5>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 text-left pt-5>
                    <span
                      style="
                        color: #333333;
                        font-family: opensansbold;
                        font-size: 20px;
                      "
                    >
                      ₹ {{ product.productPrice }} &nbsp;</span
                    >
                    <!-- v-if="product.offerPrice != product.price" -->
                    <span
                      v-if="product.offerPrice != product.price"
                      style="
                        color: #8d8d8d;
                        font-size: 12px;
                        font-family: opensansregular;
                      "
                      class="pl-1 text-decoration-line-through"
                    >
                      <!-- ₹{{ product.price }} -->
                      ₹700.00
                    </span>
                  </v-flex>
                  <v-flex xs12 pt-2 text-left>
                    <span
                      style="
                        color: #30b868;
                        font-size: 12px;
                        font-family: poppinssemibold;
                      "
                      >Free Shipping Available</span
                    >
                  </v-flex>
                  <v-flex xs12 text-left>
                    <span
                      style="
                        color: #333333;
                        font-size: 12px;
                        font-family: poppinssemibold;
                      "
                      >Category :
                      <span style="font-family: poppinsregular">{{
                        product.productCategory
                      }}</span>
                    </span>
                  </v-flex>
                  <v-flex xs12 pb-2 text-left>
                    <span
                      style="
                        color: #f28f34;
                        font-size: 12px;
                        font-family: poppinssemibold;
                      "
                      >Sold by :
                      <span style="font-family: poppinsregular; color: #333333">
                        {{ product.shopname }}</span
                      >
                    </span>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-divider></v-divider>
                  </v-flex>
                  <!-- v-if="product.size" -->
                  <v-flex xs12 sm12 text-left pt-5>
                    <v-layout wrap justify-strat>
                      <v-flex xs6 sm6 md5 lg4>
                        <v-layout wrap justify-start>
                          <v-flex xs12 sm3 md3 lg3 align-self-center>
                            <span
                              style="
                                color: #000000;
                                font-family: poppinssemibold;
                                font-size: 15px;
                              "
                              >Size</span
                            >
                          </v-flex>
                          <v-flex xs12 sm6 md7 lg7 text-left>
                            <v-card outlined>
                              <v-select
                                dense
                                v-model="size"
                                :items="sizes"
                                item-text="name"
                                item-value="value"
                                height="31px"
                                color="grey"
                                class="no-border pl-4 px-3"
                                variant="underlined"
                                :hide-details="true"
                              >
                              </v-select>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex
                        xs6
                        sm6
                        md6
                        lg5
                        pl-2
                        pl-xs-2
                        pl-sm-2
                        pl-md-0
                        pl-lg-0
                        pl-xl-0
                      >
                        <v-layout wrap>
                          <v-flex xs12 sm4 md5 lg4 align-self-center>
                            <span
                              style="
                                color: #000000;
                                font-family: poppinssemibold;
                                font-size: 15px;
                              "
                              >Quantity
                            </span>
                          </v-flex>
                          <v-flex xs12 sm6 md6 lg5>
                            <v-card outlined>
                              <!-- <v-select
                                dense
                                v-model="size"
                                :items="sizes"
                                item-text="name"
                                item-value="value"
                                height="29px"
                                color="grey"
                                class="no-border pl-4"
                                variant="underlined"
                                :hide-details="true"
                              >
                              </v-select> -->
                              <v-text-field
                                id="slotInput"
                                class="no-border px-3"
                                placeholder="1"
                                hide-details
                                dense
                                color="#CCCCCC"
                                background-color="#FFFFFF"
                                append-outer-icon="mdi-plus"
                                readonly
                                v-model="quantity"
                              >
                                <template v-slot:prepend>
                                  <v-icon
                                    @click="quantity--"
                                    :disabled="quantity <= 1"
                                  >
                                    mdi-minus
                                  </v-icon>
                                </template>
                                <template v-slot:append-outer>
                                  <v-icon
                                    :disabled="quantity >= product.stock"
                                    @click="quantity++"
                                  >
                                    mdi-plus
                                  </v-icon>
                                </template>
                              </v-text-field>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- <v-flex xs12 text-left pt-2>
                    <span
                      class="pr-2"
                      v-for="(item, i) in product.items"
                      :key="i"
                      style="padding-top: 10px !important"
                    >
                      <span v-if="item.size">
                        <v-btn
                          small
                          light
                          depressed
                          outlined
                          @click="changeSize(item)"
                          :ripple="false"
                          :color="
                            productSize == item.size ? '#FF0000' : '#3A3A3A'
                          "
                          class="sizebutton px-2"
                        >
                          <span style="font-family: poppinssemibold">{{
                            item.size
                          }}</span>
                        </v-btn>
                      </span>
                    </span>
                  </v-flex> -->
                  <!-- <v-flex xs12 sm12 text-left pt-5>
                    <span
                      v-for="(list, l) in product.items"
                      :key="l"
                      style="
                        color: #373737;
                        font-family: poppinsregular;
                        font-size: 15px;
                      "
                    >
                      <span v-if="list.stock[0].color!='null' && list.stock[0].color!=null">Colour</span>
                    </span>
                  </v-flex>
                  <v-layout wrap v-for="(data, d) in product.items" :key="d">
                    <v-flex
                      text-left
                      lg12
                      v-for="(co, c) in data.stock"
                      :key="c"
                    >
                      <v-card
                        v-if="co.color!=null && co.color!='null'"
                        outlined
                        rounded="30px"
                        class="colorselector"
                        width="30px"
                        :color="co.color ? '#ffebeb' : ''"
                      >
                        <v-layout py-2 wrap align-content-center>
                          <v-flex xs12 text-center>
                            <v-avatar :color="co.color" size="15" />
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout> -->
                  <v-flex xs12 sm12 text-left pt-8 pl-1>
                    <v-layout wrap>
                      <v-flex
                        xs6
                        sm4
                        md4
                        lg3
                        align-self-center
                      >
                        <!-- <v-btn color="#1D9A50" @click="addCart()" rounded width="150px" depressed>
                         
                          <span
                            style="
                              color: #ffffff;
                              font-family: opensanssemibold;
                              text-transform: none;
                              letter-spacing: 0px;
                            "
                          >
                            Buy now</span
                          >
                        </v-btn> -->
                        <v-icon
                      @click="addWishlist()"
                      v-if="product.isWishlisted == false"
                      color="#000000"
                      >mdi-heart-outline</v-icon
                    >
                    <v-icon v-else color="red" @click="addWishlist()"
                      >mdi-heart</v-icon
                    >
                    <span
                      v-if="product.isWishlisted == false"
                      style="
                        color: #000000;
                        font-family: poppinsmedium;
                        text-transform: none;
                        font-size: 14px;
                      "
                    >
                      &nbsp;Add to Wishlist</span
                    >
                    <span
                      v-else
                      style="
                        color: #000000;
                        font-family: poppinsmedium;
                        text-transform: none;
                        font-size: 14px;
                      "
                    >
                      &nbsp;In Wishlist</span
                    >
                      </v-flex>
                      <v-flex
                      v-if="product.isCart == false"
                        xs6
                        sm4
                        md4
                        lg3
                        px-2
                        px-xs-2
                        px-sm-0
                        px-md-0
                        px-lg-0
                        px-xl-0
                        pl-1
                        pl-xs-1
                        pl-sm-5
                        pl-md-5
                        pl-lg-5
                        pl-xl-5
                        text-left
                      >
                        <v-btn
                          color="#444645"
                          rounded
                          depressed
                          @click="checkSeller()"
                          width="150px"
                        >
                          <span
                            style="
                              color: #ffffff;
                              font-family: opensanssemibold;
                              text-transform: none;
                              letter-spacing: 0px;
                            "
                          >
                            Add to Cart</span
                          >
                        </v-btn>
                      </v-flex>
                      <v-flex
                      v-else
                        xs6
                        sm4
                        md4
                        lg3
                        px-2
                        px-xs-2
                        px-sm-0
                        px-md-0
                        px-lg-0
                        px-xl-0
                        pl-1
                        pl-xs-1
                        pl-sm-5
                        pl-md-5
                        pl-lg-5
                        pl-xl-5
                        text-left
                      >
                        <v-btn
                          color="#444645"
                          rounded
                          depressed
                          :to="'/cart'"
                          width="150px"
                        >
                          <span
                            style="
                              color: #ffffff;
                              font-family: opensanssemibold;
                              text-transform: none;
                              letter-spacing: 0px;
                            "
                          >
                            In Cart</span
                          >
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- <v-flex xs12 sm12 text-left pt-5 pl-1
                    >
                  </v-flex> -->
                  <v-flex xs12 sm12 md12 pb-5 pt-5>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      placeholder="Enter the pincode"
                      flat
                      dense
                      color="#444645"
                      v-model="pincode"
                      :hide-details="true"
                    >
                      <template v-slot:append>
                        <v-btn
                          :ripple="false"
                          text
                          @click="checkPincodeAvailability"
                          :disabled="!pincode"
                        >
                          <span
                            style="
                              text-transform: none;
                              font-family: opensanssemibold;
                            "
                            >Check</span
                          >
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 text-left v-if="pincodeMsg.status==false">
                    <span style="font-family: opensanssemibold; color:red; font-size:13px">{{ pincodeMsg.msg }}</span>
                  </v-flex>
                  <v-flex xs12 sm12 md12 pt-5 v-if="pincodeMsg.status==true">
                    <v-card
                      color="#F6F9F7"
                      outlined
                      style="border: #c8c8c8 solid 1px"
                    >
                      <v-layout wrap py-5 px-5>
                        <v-flex xs2 sm2 md2 lg1 align-self-center>
                          <v-img
                            contain
                            height="25px"
                            src="./../../assets/icons/van.png"
                          ></v-img>
                        </v-flex>
                        <v-flex xs10 sm10 md10 lg11 text-left>
                          <span
                            style="
                              font-family: poppinssemibold;
                              font-size: 14px;
                              line-height: 0px;
                            "
                            >Fast Delivery</span
                          >
                          <br />
                          <span
                            style="
                              font-family: poppinsregular;
                              font-size: 13px;
                              line-height: 0px;
                            "
                            >Benefit from our quick and dependable delivery
                            service</span
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout wrap pb-5 px-5>
                        <v-flex xs2 sm2 md2 lg1 align-self-center>
                          <v-img
                            contain
                            height="25px"
                            src="./../../assets/icons/card.png"
                          ></v-img>
                        </v-flex>
                        <v-flex xs10 sm10 md10 lg11 text-left>
                          <span
                            style="
                              font-family: poppinssemibold;
                              font-size: 14px;
                            "
                            >Secure Payments</span
                          >
                          <br />
                          <span
                            style="
                              font-family: poppinsregular;
                              font-size: 13px;
                              line-height: 0px;
                            "
                            >Shop with confidence using our safe and trusted
                            payment options.</span
                          >
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 sm12 py-3>
        <AvailableSimilarProducts :similarProducts="similarProducts" />
      </v-flex>

      <v-flex xs12 py-6>
        <v-tabs v-model="tabValue" grow background-color="white" color="#056848">
          <v-tab href="#tab-1">
            <span :style="{ color: tabValue === 'tab-1' ? '#056848' : 'black', fontFamily: 'poppinssemibold' }"
              >Customer Reviews</span
            ></v-tab
          >
          <v-tab dark href="#tab-2">
            <span :style="{ color: tabValue === 'tab-2' ? '#056848' : 'black', fontFamily: 'poppinssemibold' }"
              >Product Specifications</span
            ></v-tab
          >
          <v-tab dark href="#tab-3"
            ><span :style="{ color: tabValue === 'tab-3' ? '#056848' : 'black', fontFamily: 'poppinssemibold' }"
              >Product Description</span
            ></v-tab
          >

          <v-tab-item value="tab-1">
            <v-card flat>
              <v-layout wrap justify-start py-5>
                <v-flex xs12 pl-3 text-left>
                  <ProductReview @stepper="winStepper" />
                </v-flex>
              </v-layout>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-2">
            <v-card flat>
              <v-layout wrap justify-start py-5>
                <v-flex xs12 pl-3 text-left>
                  <ProductSpec @stepper="winStepper" />
                </v-flex>
              </v-layout>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-3">
            <v-card flat>
              <v-layout wrap justify-start py-5>
                <v-flex xs12 pl-3 text-left>
                  <ProductDes @stepper="winStepper" />
                </v-flex>
              </v-layout>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-flex>
      <!-- <v-flex xs12 v-if="relatedProducts.length > 0">
        <v-divider></v-divider>
      </v-flex> -->
      <!-- v-if="relatedProducts.length > 0" -->
      <v-flex xs12 sm12 py-3>
        <SimilarProducts :relatedProducts="relatedProducts" 
        @wishlistUpdated="getProducts" />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import InnerImageZoom from "vue-inner-image-zoom";
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
// import ImageZoomer from "./imageZoomer";
import ProductReview from "./productReview";
import SimilarProducts from "./similarProducts";
import AvailableSimilarProducts from "./availableProducts";
import ProductSpec from "./productSpec";
import ProductDes from "./productDes";

export default {
  //props: ["productData", "productPhotos"],
  components: {
    // ImageZoomer,
    "inner-image-zoom": InnerImageZoom,
    ProductReview,
    SimilarProducts,
    AvailableSimilarProducts,
    ProductSpec,
    ProductDes,
  },
  //  metaInfo: {
  //   title: 'Hello World!'
  // },
  data() {
    return {
      tabValue: "tab-1",
      appLoading: false,
      wishlistLoading: false,
      cartLoading: false,
      showSnackBar: false,
      timeout: 5000,
      ServerError: false,
      msg: null,
      shopDialog: false,
      Rules: [(v) => !!v || "Required"],
      product: {},
      productData: {},
      productArray: [],
      curProduct: null,
      curProductEdit: null,
      productSize: {},
      selectedProduct: {},
      curImage: null,
      sizeChart: null,
      sizeChartDialog: false,
      shareDialog: false,
      dialogChange: false,
      pincode: "",
      pincodeMsg: "",
      rating: 0,
      quantity: 1,
      stock: "",
      productImage: "",
      confirmReplace:"",
      wishlist: [],
      list: [],
      limit: "",
      reviews: [],
      relatedProducts: [],
      similarProducts: [],
      items: ["500 gm", "250 gm"],
      itemId: "",
      size: "",
      sizes: ["500 gm", "250 gm"],
      images: [
        { img: require("./../../assets/images/image38.png") },
        { img: require("./../../assets/images/image38.png") },
      ],
    };
  },
  computed: {
    appLogin() {
      if (this.$store.state.isLoggedIn) return this.$store.state.isLoggedIn;
      else return null;
    },
    appUserId() {
      return this.$store.state.id;
    },
    UserId() {
      return this.$store.state.userId;
    },
  },
  beforeMount() {
    this.getProducts();
  },
  methods: {
    winStepper(item) {
      window.scrollTo(0, 0);
      if (item.ref == "page1Tab") {
        if (item.level) {
          this.tabValue = item.level;
        }
      }
    },
    changeSize(item) {
      this.productSize = item.size;
      for (var i = 1; i <= item.stock[0].stock; i++) {
        this.list.push(i);
      }
      this.product.offerPrice = item.offerPrice;
      this.product.price = item.price;
      this.itemId = item._id;
      this.product.instock = item.instock;
      this.product.size = item.size;
      this.product.inWishList = item.inWishList;
      this.product.inCart = item.inCart;
    },
    showImage(item) {
      this.curImage = item;
    },
    getProducts() {
      this.appLoading = true;
      // var headers1 = {};
      // if (this.appLogin) {
      //   headers1 = {
      //     token: localStorage.getItem("token"),
      //   };
      // } else {
      //   headers1 = {
      //     guestId: localStorage.getItem("userId"),
      //   };
      // }
      axios({
        url: "/product/view",
        method: "POST",
        data: {
          productId: this.$route.query.id,
          productName: this.$route.query.productName,
          id: localStorage.getItem("id"),
          guestId: localStorage.getItem("userId"),
        },
        // headers: headers1,
      })
        .then((response) => {
          this.appLoading = false;
          this.product = response.data.product;
          this.reviews = response.data.review;
          this.productData = this.product;
          this.relatedProducts = response.data.relatedProducts;
          this.relatedProducts = response.data.otherProducts;

          if (this.product) {
            if (this.product.items.length > 0) {
              this.changeSize(this.product.items[0]);
              this.productSize = this.product.items[0].size;
              this.product.instock = this.product.items[0].instock;
              this.product.size = this.product.items[0].size;
              this.product.inWishList = this.product.items[0].inWishList;
              this.product.inCart = this.product.items[0].inCart;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
    checkSeller() {
      this.appLoading = true;
      axios({
        url: "/cart/check",
        method: "POST",
        data: {
          id: localStorage.getItem("id"),
          guestId: localStorage.getItem("userId"),
          productId: this.$route.query.id,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            // this.cart = response.data.data;
            // this.$store.commit("changeCart", response.data.totalLength);
            // this.$router.push("/cart");
            this.confirmReplace=response.data.confirmReplace
            // if (response.data.confirmReplace==true) {
            //   this.dialogChange = true;
            // } else {
              this.addCart();
            // }
          } else {
            this.confirmReplace=response.data.confirmReplace
            // this.msg = response.data.msg;
            // this.showSnackBar = true;
            this.dialogChange = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    checkPincodeAvailability() {
      axios({
        url: "user/product/pincode/check",
        method: "POST",
        data: {
          productId: this.$route.query.id,
          pincode:this.pincode
        }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.pincodeMsg=response.data
            // this.msg = response.data.msg;
            // this.showSnackBar = true;
          } else {
            this.pincodeMsg=response.data
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addCart() {
      this.appLoading = true;
      // var headers1 = {};
      // if (this.appLogin) {
      //   headers1 = {
      //     token: localStorage.getItem("token"),
      //   };
      // } else {
      //   headers1 = {
      //     guestId: localStorage.getItem("userId"),
      //   };
      // }
      axios({
        url: "/addtocart/add",
        method: "POST",
        data: {
          id: localStorage.getItem("id"),
          guestId: localStorage.getItem("userId"),
          productId: this.$route.query.id,
          qty: this.quantity,
          confirmReplace:this.confirmReplace
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.cart = response.data.data;
            this.$store.commit("changeCart", response.data.cartCount);
            this.$store.commit("changeWishlist", response.data.wishListCount);
            this.$router.push("/cart");
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addWishlist() {
      this.appLoading = true;
      var headers1 = {};
      if (this.appLogin) {
        headers1 = {
          token: localStorage.getItem("token"),
        };
      } else {
        headers1 = {
          guestId: localStorage.getItem("userId"),
        };
      }
      axios({
        url: "/user/wishList/Add",
        method: "POST",
        data: {
          productId: this.$route.query.id,
          customerId: localStorage.getItem("id"),
          guestId: localStorage.getItem("userId"),
          // quantity:this.quantity
        },
        headers: headers1,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.wishlist = response.data.data;
            this.$store.commit("changeWishlist", response.data.wishListCount);
            //this.$router.push("/wishlist");
            this.getProducts();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.theme--light.v-text-field.no-border
  > .v-input__control
  > .v-input__slot::before {
  border-width: 0;
}

.container {
  position: relative;
  text-align: center;
  color: white;
}

/* Bottom left text */
.top-left {
  position: absolute;
  top: 12px;
  left: 11px;
}

.top-left-xs {
  position: absolute;
  top: 12px;
  left: 11px;
}

.bottom-right-xs {
  position: absolute;
  bottom: -8vh;
  right: 20px;
}

.bottom-right-sm {
  position: absolute;
  bottom: -7vh;
  right: 12px;
}

.bottom-right-md {
  position: absolute;
  bottom: -7vh;
  right: 10px;
}

.bottom-right {
  position: absolute;
  bottom: -8vh;
  right: 10px;
}

.colorselector.v-sheet.v-card {
  border-radius: 35px;
}

.sizebutton.v-btn:not(.v-btn--round).v-size--small {
  padding: 0 12px !important;
  min-width: 30px !important;
}

.rectangle2 {
  height: 20px;
  width: 100%;
  padding: 2%;
  opacity: 0.8;
}

.triangle-rights3 {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.8;
}

.triangle-rights2 {
  margin-left: -38px;
  width: 0;
  height: 0;
  border-top: 0px solid transparent;
  border-bottom: 20px solid transparent;
  opacity: 0.8;
}

.triangle-rights1 {
  margin-left: -80px;
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 0px solid transparent;
  opacity: 0.8;
}

@media only screen and (max-width: 374px) {
  .rectangle2 {
    height: 20px;
    width: 100%;
    padding: 0%;
    opacity: 0.8;
  }

  .triangle-rights3 {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: 0.8;
  }

  .triangle-rights2 {
    margin-left: -33px;
    width: 0;
    height: 0;
    border-top: 0px solid transparent;
    border-bottom: 20px solid transparent;
    opacity: 0.8;
  }

  .triangle-rights1 {
    margin-left: -56px;
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 0px solid transparent;
    opacity: 0.8;
  }

  @media only screen and (min-width: 373px) and (max-width: 424px) {
    .rectangle2 {
      height: 20px;
      width: 100%;
      padding: 0%;
      opacity: 0.8;
    }

    .triangle-rights3 {
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      opacity: 0.8;
    }

    .triangle-rights2 {
      margin-left: -50px;
      width: 0;
      height: 0;
      border-top: 0px solid transparent;
      border-bottom: 20px solid transparent;
      opacity: 0.8;
    }

    .triangle-rights1 {
      margin-left: -86px;
      width: 0;
      height: 0;
      border-top: 20px solid transparent;
      border-bottom: 0px solid transparent;
      opacity: 0.8;
    }
  }
}

@media only screen and (min-width: 748px) and (max-width: 1023px) {
  .top-left {
    position: absolute;
    top: 18px;
    left: 40px;
  }

  .rectangle2 {
    height: 20px;
    width: 100%;
    padding: 0%;
    opacity: 0.8;
  }

  .triangle-rights3 {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: 0.8;
  }

  .triangle-rights2 {
    margin-left: -100px;
    width: 0;
    height: 0;
    border-top: 0px solid transparent;
    border-bottom: 20px solid transparent;
    opacity: 0.8;
  }

  .triangle-rights1 {
    margin-left: -170px;
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 0px solid transparent;
    opacity: 0.8;
  }
}
</style>